import React, { useContext } from 'react';
import classnames from 'classnames';

import { Svg } from '../Svg/Svg';
import { MOBILE_SEARCH_INPUT_ID } from '../Algolia/SearchDropdown/SearchLoader';

import classes from './HeaderControls.scss';
import { BasketIcon } from './BasketIcon';
import { AccountIcon } from './AccountIcon';
import { HeaderContext } from './Header';
import { CreditBalance } from './CreditBalance';

type HeaderControlsProps = {
    whiteIcons: boolean;
};

export const HeaderControls: React.FC<HeaderControlsProps> = React.memo(({ whiteIcons }) => {
    const { showNav, setShowNav, setShowSearch, creditAvailable, creditMax } = useContext(HeaderContext);

    return (
        <div className={classes.headerControls}>
            <button
                type="button"
                className={classnames(
                    'headerControl',
                    [classes.headerControl],
                    [classes.headerControlMenu],
                    ['button--reset'],
                    {
                        [classes.headerControlMenuActive]: showNav,
                    },
                )}
                onClick={(event) => {
                    event.stopPropagation();
                    setShowSearch(false);
                    setShowNav((isOpen) => !isOpen);
                }}
            >
                {!showNav && (
                    <>
                        <Svg name="menu" /> <span className={classes.headerControlText}>Menu</span>
                    </>
                )}
                {showNav && (
                    <>
                        <Svg name="close" /> <span className={classes.headerControlText}>Close</span>
                    </>
                )}
            </button>
            <button
                type="button"
                className={classnames(
                    'headerControl',
                    [classes.headerControl],
                    [classes.headerControlSearch],
                    ['button--reset'],
                )}
                onClick={(event) => {
                    event.stopPropagation();
                    setShowNav(false);
                    document.getElementById(MOBILE_SEARCH_INPUT_ID)?.focus();
                }}
            >
                <Svg name="search" /> <span className={classes.headerControlText}>Search</span>
            </button>
            <AccountIcon whiteIcons={whiteIcons} />
            {creditAvailable !== undefined && creditMax !== undefined && creditAvailable > 0 && (
                <CreditBalance creditAvailable={creditAvailable} creditMax={creditMax} />
            )}
            <BasketIcon whiteIcons={whiteIcons} />
        </div>
    );
});
